// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"RequestTerms_rootContainer__1PCSp","legalContent":"RequestTerms_legalContent__129Rc"};